export const sources = {
	webp: "__VITE_ASSET__TX5a1iViCylaCWPFSCQG2w__ 500w, __VITE_ASSET__y3WuTrdTs_Si7uYpRddj9w__ 800w, __VITE_ASSET__kSHvwCjLFxLpY3FM1MyAsA__ 1080w, __VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__ 1200w"
};
export const img = {
	src: "__VITE_ASSET__U6muqRGa8aHtq8t0c9wAzg__",
	w: 1200,
	h: 776
};
export default {
	sources: sources,
	img: img
};
